import { RouteConfig } from 'vue-router';

import { getMessageData } from '@/utils/message';

export const systemMessageDetailsRoute: RouteConfig = {
  path: ':messageId',
  name: 'systemMessage',
  component: () => import(/* webpackChunkName: "systemMessage" */ '@/views/mainRoute/systemMessage/View.vue'),
  meta: { breadcrumb: { title: 'Powiadomienie', name: 'systemMessage' } },
  beforeEnter: (to, from, next) => {
    getMessageData(to, from, next);
  }
};
